export enum Categories {
  EventReminders = 'Event Reminders',
}

export const CategoryNames = Object.values(Categories);
